import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import EmployeesComponent from '../components/EmployeesComponent'

const mapStateToProps = (state) => {
  return {
    employees: state.employees,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeesComponent)
